import { Bell } from "lucide-react";
import { MobileNav } from "@/components/layout/MobileNav";
import { WeddingSwitcher } from "@/components/layout/WeddingSwitcher";
import { UserMenu } from "@/components/layout/UserMenu";
import { Button } from "@/components/ui/button";
import { APP_NAME } from "@/lib/constants";
import { Link, useLocation } from "react-router-dom";
import { useNotifications } from "@/contexts/NotificationContext";
import { useLanguage } from "@/contexts/LanguageContext";

export function TopNav() {
  const { pathname } = useLocation();
  const inWedding = /^\/weddings\/[^/]+/.test(pathname);
  const { unreadCount } = useNotifications();
  const { language, t } = useLanguage();
  return (
    <header className="sticky top-0 z-30 flex h-16 shrink-0 items-center gap-3 border-b border-border bg-background/85 px-4 backdrop-blur supports-[backdrop-filter]:bg-background/70 sm:px-6">
      <MobileNav />

      <div className="min-w-0 flex-1">
        {inWedding ? <WeddingSwitcher /> : <span className="font-display text-base font-semibold">{APP_NAME}</span>}
      </div>

      <Button asChild variant="ghost" size="icon" className="relative">
        <Link to="/notifications" aria-label={`${t("Notifications")}${unreadCount ? language === "es" ? `, ${unreadCount} sin leer` : `, ${unreadCount} unread` : ""}`}>
          <Bell className="h-4 w-4" />
          {unreadCount > 0 && <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-semibold text-primary-foreground">{unreadCount > 9 ? "9+" : unreadCount}</span>}
        </Link>
      </Button>

      <UserMenu />
    </header>
  );
}
